import { render, staticRenderFns } from "./ListChanged.vue?vue&type=template&id=442de3a5&scoped=true&"
import script from "./ListChanged.vue?vue&type=script&lang=js&"
export * from "./ListChanged.vue?vue&type=script&lang=js&"
import style0 from "./ListChanged.vue?vue&type=style&index=0&id=442de3a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442de3a5",
  null
  
)

export default component.exports